export default {
	app() {
		return this.$root.$children[0];
	}
};
